<template>
  <div>
    <div class="mt-3 aulas-btns">
      <v-btn icon to="/diario-escolar">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>
    <div class="mt-2">
      <v-alert v-if="msgError" type="error" value="true" style="color: white;">
        <div>{{ msgError }}</div>
      </v-alert>
      <table v-else class="table-siged">
        <thead>
          <tr>
            <th>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"  size="20" >notification_important</v-icon>
                  </template>
                  <span class="text-caption white--text">Dê um duplo clique no nome do aluno abaixo para visualizar <br>informações de contato sobre o respectivo aluno.</span>
              </v-tooltip>
              Alunos
            </th>
            <th v-for="periodo in periodos" :key="periodo.id">{{ periodo.dspravadi }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="aluno in alunos" :key="aluno.id">
            <td style="cursor: pointer;" @dblclick="dadosContatoAluno = {dialog: true, cdtipesc: aluno.cdtipesc, cdescola: aluno.cdescola, numatalun: aluno.numatalun};">{{ aluno.nmaluno }}</td>
            <td class="centro" v-for="(periodo, index) in periodos" :key="periodo.id">
              <v-btn
                icon
                style="color: gray"
                :to="{ name: 'diario-escolar-parecer-descritivo-aluno', params: parametrosLink(aluno, periodo, periodos.length - 1 === index) }">
                <v-icon>{{ verificarIcone(aluno, periodo.cdpravadi) }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>

      <ContatoAluno v-bind.sync="dadosContatoAluno" />


    </div>
  </div>
</template>

<script>
import ContatoAluno from '@/components/ContatoAluno';
import store from '@/store/index';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

export default {
  name: 'AlunosPerecer',
  components: {
    ContatoAluno
  },
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    cdinstruc: [Number],
    tipoDeEnsino: [String]
  },
  data() {
    return {
      alunos: [],
      periodos: [],
      dadosContatoAluno: {},
    };
  },
  async beforeRouteEnter(to, from, next){
    if(typeof to.params.ano === 'undefined' || typeof to.params.cdturma === 'undefined' || typeof to.params.disciplina === 'undefined'){
      return next('/diario-escolar');
    }
    try {
      const { data } = await DiarioEscolarRepository.getListarAlunosPDI({
        ...dadosUser(),
        aaletivo: to.params.ano,
        cdturma: to.params.cdturma,
        cddiscipl: to.params.disciplina,
      });
      return next(vm => {
        vm.load(data.results);
      });
    } catch(error) { }
  },
  methods: {
    load({ alunos, periodos }) {
      this.alunos = alunos;
      this.periodos = periodos;
      this.$Progress.finish();
    },
    parametrosLink(aluno, periodo, ultimoPeriodo) {
      return {
        ano: this.ano,
        cdturma: this.cdturma,
        cdinstruc: this.cdinstruc,
        disciplina: this.disciplina,
        numatalun: aluno.numatalun,
        cdpravadi: periodo.cdpravadi,
        ultimoPeriodo,
        tipoDeEnsino: this.tipoDeEnsino,
      };
    },
    verificarIcone(aluno, cdpravadi) {
      return (aluno.lancados.indexOf(cdpravadi) >= 0)? 'check' : 'remove';
    },
  },
  computed: {
    msgError() {
      if(this.alunos.length === 0) { return 'Nenhum aluno encontrado!'; }
      if(this.periodos.length === 0) { return 'Nenhum período avaliativo encontrado!'; }
      return '';
    }
  },
}
</script>

<style>

</style>
